import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets the scroll position to the top of the page on every route change.
 * Without this, react-router preserves the previous scroll offset, so a
 * navigation from far down one page lands mid-way down the next one
 * (most jarring on the Booking/Contact pages reached from a footer link).
 *
 * NOTE on the scroll container: index.css sets `html, body { height: 100%;
 * overflow-x: hidden }`. Per the CSS spec, `overflow-x: hidden` forces the
 * other axis to compute to `auto`, which combined with the fixed height makes
 * `<body>` (not the window / documentElement) the actual vertical scroller.
 * `window.scrollTo(0, 0)` therefore does NOT reset it, so we reset every
 * candidate scroller explicitly.
 *
 * The `hash` guard is required: when a link targets an in-page anchor
 * (e.g. the Home product cards link to `/no/produkter#bookingflyt`),
 * ProductsPage runs its own scrollIntoView effect — we must not fight it
 * by forcing the page back to the top.
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
    if (document.scrollingElement) document.scrollingElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
    if (document.documentElement) document.documentElement.scrollTop = 0;
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
